import type { PaymentStatus } from '@tcrd/shared';

export interface PaymentDto {
  id: string;
  status: PaymentStatus;
  currency: string;
  fareAmount: string;
  adjustments: string;
  totalDue: string;
  farePaid: string;
  tipTotal: string;
  changeReturned: string;
  balance: string;
  reportedAmount: string;
  ride: { id: string; code: string; status: string; scheduledAt: string; completedAt: string | null; originAddress: string; destAddress: string; serviceType: { name: string } } | null;
  package: { id: string; billingMode: string; periodStart: string; periodEnd: string } | null;
  customer: { id: string; name: string };
  driver: { id: string; name: string };
  canCollect: boolean;
  transactions: Array<{
    id: string;
    type: 'FARE' | 'TIP' | 'CHANGE_RETURNED' | 'ADJUSTMENT';
    method: 'CASH' | 'TRANSFER' | null;
    amount: string;
    status: 'REPORTED' | 'CONFIRMED' | 'REJECTED' | 'VOIDED';
    reference: string | null;
    note: string | null;
    recordedByRole: string;
    receivedAt: string;
    confirmedAt: string | null;
    voidReason: string | null;
  }>;
  evidences: Array<{ id: string; note: string | null; url: string; createdAt: string }>;
  updatedAt: string;
}

export const TX_TYPE: Record<string, string> = { FARE: 'Tarifa', TIP: 'Propina', CHANGE_RETURNED: 'Cambio devuelto', ADJUSTMENT: 'Ajuste' };
export const TX_METHOD: Record<string, string> = { CASH: 'Efectivo', TRANSFER: 'Transferencia' };
export const TX_STATUS: Record<string, string> = { REPORTED: 'Reportado', CONFIRMED: 'Verificado', REJECTED: 'Rechazado', VOIDED: 'Anulado' };
